(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-footer.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/quickplay-modal-footer.js');
"use strict";

var _svs$core$config$data;

const {
  useCallback
} = React;
const {
  ReactIcon: Icon
} = svs.ui;
const {
  ReactButton: Button
} = svs.ui;
const {
  productIds
} = svs.utils.products;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  getSystemPrice
} = svs.components.lbUi;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  helpers: {
    is1X2,
    getNumberOfRows
  }
} = svs.components.sport.quickplayModal;
const {
  usePlaceBet
} = svs.components.sport.quickplayModal.placeBet;
const isSelfService = ((_svs$core$config$data = svs.core.config.data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.isSelfService) || false;
const {
  getPixHandler
} = svs.components.sport.pixHandler;
const SystemInfo = _ref => {
  let {
    productId,
    isMobile,
    isPixMix
  } = _ref;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const pixData = pixHandler.getModel(productId);
  const {
    systemCost,
    systemType,
    rowPrice
  } = pixHandler.getProduct(productId);
  const shouldShowHedges = is1X2(productId) && productId !== productIds.CHALLENGE;
  const mobileIconSize = shouldShowHedges ? 100 : 200;
  const notMobileIconSize = shouldShowHedges ? 200 : 300;
  const iconSize = isMobile ? mobileIconSize : notMobileIconSize;
  const game1X2Signs = pixData || [];
  const halfHedges = shouldShowHedges ? game1X2Signs.filter(row => row.filter(Boolean).length === 2).length : null;
  const fullHedges = shouldShowHedges ? game1X2Signs.filter(row => row.filter(Boolean).length === 3).length : null;
  const systemPrice = getSystemPrice(systemCost, systemType, productId);
  const rows = getNumberOfRows(systemPrice, rowPrice);
  return React.createElement("p", {
    className: "system-info-list f-550 margin-bottom-1 margin-top-half"
  }, Boolean(shouldShowHedges) && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "system-size"
  }, React.createElement(Icon, {
    className: "margin-right-half",
    color: "white",
    icon: "hedge-full",
    size: iconSize
  }), React.createElement("span", {
    className: "f-400 f-bold"
  }, fullHedges), React.createElement(Icon, {
    className: "margin-left-1 margin-right-half",
    color: "white",
    icon: "hedge-half",
    size: isMobile ? mobileIconSize : notMobileIconSize
  }), React.createElement("span", {
    className: "f-400 f-bold"
  }, halfHedges)), React.createElement("span", {
    className: "f-400"
  }, "".concat(formatCurrency(systemPrice), " kr"))), !shouldShowHedges && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "system-size"
  }, React.createElement(Icon, {
    className: "margin-right-1",
    color: "white",
    icon: "rows-three",
    size: iconSize
  }), "Rader:\xA0", React.createElement("span", {
    className: "f-bold"
  }, rows), "\xA0st"), React.createElement("span", null, "".concat(formatCurrency(systemPrice), " kr"))));
};
const QuickplayModalFooter = _ref2 => {
  let {
    drawData,
    wallet,
    handleClose,
    hasSaveButton,
    competitionBranding,
    isPixMix,
    handleRedirect
  } = _ref2;
  const {
    productId
  } = drawData;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const {
    systemCost,
    systemType
  } = pixHandler.getProduct(productId);
  const systemPrice = getSystemPrice(systemCost, systemType, productId);
  const {
    placeBet
  } = usePlaceBet();
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const _submit = useCallback(() => {
    if (hasSaveButton) {
      handleClose();
    } else {
      var _svs$components$dialo;
      const infoType = svs.sport.GrassrootsToaster().INFO_TYPE;
      const grassRootsToasterOptions = (_svs$components$dialo = svs.components.dialog) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.api) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.queue) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.areas) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.toaster) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.items) === null || _svs$components$dialo === void 0 || (_svs$components$dialo = _svs$components$dialo.find(item => {
        var _item$options;
        return ((_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.infoType) === infoType;
      })) === null || _svs$components$dialo === void 0 ? void 0 : _svs$components$dialo.options;
      if (grassRootsToasterOptions) {
        grassRootsToasterOptions.convertToPopup = false;
      }
      placeBet({
        productId,
        drawData,
        wallet,
        closeCallback: handleClose,
        isPixMix,
        handleRedirect,
        setKeepOpenItem: true
      });
    }
  }, [hasSaveButton, handleClose, placeBet, productId, drawData, wallet, isPixMix, handleRedirect]);
  const competitionBrand = competitionBranding && "quickplay-pix-".concat(competitionBranding);
  const pixLogo = React.createElement("div", {
    className: "quickplay-pix-logo no-text-selection"
  }, React.createElement("div", {
    className: "quickplay-pix-container"
  }, React.createElement("p", {
    className: "quickplay-pix-content margin-bottom-0 bg-navy ".concat(isMobile ? 'f-600' : 'f-800', " ").concat(competitionBrand ? competitionBrand : '')
  }, React.createElement("span", {
    className: "f-bold"
  }, "PIX!"), ' ', React.createElement("span", {
    className: "f-normal"
  }, "F\xE4rdiga\xA0spel. Helt\xA0enkelt."))));
  const payFooter = React.createElement("div", {
    className: "padding-2 bg-navy no-text-selection ".concat(competitionBrand ? competitionBrand : '')
  }, React.createElement("div", {
    className: isMobile ? 'f-500' : 'f-600'
  }, React.createElement(SystemInfo, {
    isMobile: isMobile,
    isPixMix: isPixMix,
    productId: productId
  })), React.createElement(Button, {
    block: true,
    className: "js-initial-focus ".concat(competitionBrand ? "".concat(competitionBrand, "--pay-btn") : ''),
    "data-testid": "quickplay-modal-pay-button",
    focus: true,
    onClick: _submit,
    size: 300
  }, Boolean(isSelfService) && React.createElement(React.Fragment, null, "L\xE4gg i varukorgen", React.createElement("br", null), "(".concat(systemPrice, " kr)")), !isSelfService && !hasSaveButton && "Betala", hasSaveButton && "Spara"));
  return React.createElement("div", {
    className: "quickplay-modal-footer"
  }, pixLogo, payFooter);
};
setGlobal('svs.components.sport.quickplayModal.QuickplayModalFooter', QuickplayModalFooter);

 })(window);